import { render, staticRenderFns } from "./EstadisticasInventarioArmas.vue?vue&type=template&id=3c973298"
import script from "./EstadisticasInventarioArmas.vue?vue&type=script&lang=js"
export * from "./EstadisticasInventarioArmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports